import { Resolver } from "found-relay";
import { environment } from "../relay";
import { Router } from "./Router";

export const Root = () => <Router resolver={new Resolver(environment)} />;
